import { Tab } from 'bootstrap';
import { FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-companies-view',
  templateUrl: './view-companies-view.component.html',
  styleUrls: ['./view-companies-view.component.css']
})
export class ViewCompaniesViewComponent implements OnInit {
  total:any;
  searchForm:FormGroup;
  currTab:Tab
  constructor() { }

  ngOnInit() {
  }
  pagination(event){}

  deleteUser(){}
}
